/* global axios */
import ApiClient from './ApiClient';

class CortexModelRouteProfilesAPI extends ApiClient {
  constructor() {
    super('cortex/model_route_profiles', { accountScoped: true });
  }

  apply(id) {
    return axios.post(`${this.url}/${id}/apply`);
  }
}

export default new CortexModelRouteProfilesAPI();
